import React from 'react'
import Eula from '../eula'

const EulaSv = () => {
    return <Eula languageCode="sv" />
}

export default EulaSv
